

import {Routes,Route, useLocation} from "react-router-dom"
import AboutP from "./AboutPage"
import ContactUs from "./Contact"
import HomepageP from "./HomePage"
import ProjectsP from "./ProjectPage"
import SkillsP from "./SkillsPage"
import {AnimatePresence} from 'framer-motion'
function AllRoutes(){
  const location = useLocation()
    return(
        <AnimatePresence>
       <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HomepageP/>}/>
        <Route path="/about" element={<AboutP/>}/>
        <Route path="/projects" element={<ProjectsP/>}/>
        <Route path="/skills" element={<SkillsP/>}/>
        <Route path="/contactus" element={<ContactUs/>}/>
       </Routes>
       </AnimatePresence>
    )
}

export default AllRoutes